import firebase from 'firebase';

export const githubProvider = new firebase.auth.GithubAuthProvider();
